import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Popover, Svg, Text } from '@hopskipdrive/react-components';
import { ArrowDropDown } from '@mui/icons-material';
import { Stack } from '@mui/material';

import { useGetOffenderTypes } from '../../../hooks/useIncidentApi';
import { ValueIcon } from '../FilterPanel.helper';
import { CloseButton, FilterButton, FilterTypeContainer } from '../FilterPanel.styles';

import { ReportedPartyChip } from './ReportedPartyFilter.styles';

export const ReportedPartyFilter = () => {
  const { data: offenderTypeResponse } = useGetOffenderTypes();
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const hasType = params.offenderType && params.offenderType.length > 0;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePartyChange = (value: string, label: string) => {
    const newSelectedItems = { value, label };
    const newParams = new URLSearchParams(searchParams);

    if (searchParams.get('page')) {
      newParams.set('page', '1');
    }

    newParams.set('offenderType', encodeURIComponent(JSON.stringify(newSelectedItems)));
    setSearchParams(newParams);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'status-filter-popover' : undefined;

  return (
    <>
      <FilterButton variant="text" open={open} active={Boolean(hasType)} onClick={handleOpen}>
        Alleged Offender
        <ArrowDropDown />
      </FilterButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ '.MuiBackdrop-root': { backgroundColor: 'transparent' } }}
      >
        <FilterTypeContainer sx={{ width: '20rem' }}>
          <Box className="filter-header">
            <Text variant="body2">Filter by Alleged Offenders</Text>
            <CloseButton onClick={handleClose}>
              <Svg icon="cross" />
            </CloseButton>
          </Box>
          {offenderTypeResponse && offenderTypeResponse.data.length && (
            <Stack className="filter-options" spacing={2}>
              {offenderTypeResponse.data.map((option, index) => (
                <ReportedPartyChip
                  key={index}
                  className={`status-${option.value}`}
                  icon={<ValueIcon value={option.value} />}
                  label={option.label}
                  variant="outlined"
                  onClick={() => {
                    handlePartyChange(option.value, option.label);
                    handleClose();
                  }}
                />
              ))}
            </Stack>
          )}
        </FilterTypeContainer>
      </Popover>
    </>
  );
};
